import Model from 'flarum/common/Model';

export default class KnowledgeLevel extends Model {}

Object.assign(KnowledgeLevel.prototype, {
  code: Model.attribute('code'),
  name: Model.attribute('name'),
  studentLevelRestriction: Model.attribute('student_level_restriction'),
  sortOrder: Model.attribute('sort_order'),
  isActive: Model.attribute('is_active'),
  createdAt: Model.attribute('created_at', Model.transformDate),
  updatedAt: Model.attribute('updated_at', Model.transformDate),

  modules: Model.hasMany('modules'),
  courses: Model.hasMany('courses'),
});
